var map = {
	"./1.jpg": 2228,
	"./10.jpg": 2229,
	"./2.jpg": 2230,
	"./3.jpg": 2231,
	"./4.jpg": 2232,
	"./5.jpg": 2233,
	"./6.jpg": 2234,
	"./7.jpg": 2235,
	"./8.jpg": 2236,
	"./9.jpg": 2237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2227;